import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgScrollbarModule, provideScrollbarOptions } from "ngx-scrollbar";

import { CoreCommonModule } from "@core/common.module";
import { CoreTouchspinModule } from "@core/components/core-touchspin/core-touchspin.module";

import { NavbarComponent } from "app/layout/components/navbar/navbar.component";
import { Dialog } from "app/common/dialog";
import { TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "app/common/shared.module";

@NgModule({
  declarations: [NavbarComponent],
  imports: [
    RouterModule,
    NgbModule,
    CoreCommonModule,
    NgScrollbarModule,
    CoreTouchspinModule,
    TranslateModule.forChild(),
    SharedModule,
  ],
  providers: [
    Dialog,
    provideScrollbarOptions({
      visibility: "hover",
      appearance: "compact",
    }),
  ],
  exports: [NavbarComponent],
})
export class NavbarModule {}
